query PopulationsFilter($filterId: ID, $scenarioId: ID!, $pagination: PaginationInput) {
  filter(scenarioId: $scenarioId) {
    populations(filterId: $filterId, pagination: $pagination) {
      items {
        id
        code
        size
        level
        campus {
          id
          code
          name
        }
        modality {
          id
          code
        }
        shift {
          id
          code
        }
        program {
          id
          code
          name
        }
        curriculum
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        page
        size
        total
      }
    }
  }
}
